import React, { Component } from 'react'
// import './css/navbar2.css'
import Logo from '../../assets/image/logo.png'
import SublistServices from './sublist_services'
export default class navbar2 extends Component {
    render() {
        return (
            <>
                 <SublistServices/>
            <nav>
            <div className='navbar2'>
                <div className='navbar2-logo'>
                    <img src={Logo} alt="logo" onClick={()=>window.location.assign('/')}/>
                </div>
               

                <div className='navbar2-list'>
                    <div className='navbar2-list-item'>
                        <a href="#" tabIndex={1} className='list-services'>Services</a>
                        
                    </div>
                    <div className='navbar2-list-item'>
                        <a href="#" tabIndex={1} className='list-publication'>Publication</a>
                        <div className='sublist-publication'>
                            <ul>
                                <li><a href="/publication/booklist">Book list</a></li>
                                <li><a href="/publication/whitepaper">Whitepaper</a></li>
                                <li><a href="/publication/insight">Insight</a></li>
                                <li><a href="/publication/bulletin">Knowledge capital bulletin</a></li>

                            </ul>
                        </div>
                    </div>
                    <a href="#" className='list-navbar'>Event</a>
                    <a href="#" className='list-navbar'>Carrers</a>
                    <a href="#" className='list-navbar'>About Us</a>
                </div>
            </div>
             </nav>
             </>
        )
    }
}
